import { useIsAdminRole } from 'modules/common/hooks/useIsAdminRole';
import { useIsEditorRole } from 'modules/common/hooks/useIsEditorRole';
import { useAppSelector } from 'modules/common/hooks/redux';
import {
  isProjectStatusDecline,
  isProjectStatusDone,
  isProjectStatusNew,
  isProjectStatusEditorPending,
  isWebSiteUpToDateSelector,
  isProjectStatusProoferPending,
  isProjectStatusAssigned,
  isProjectStatusEditingInProgress,
  isProjectStatusInReTake,
} from 'redux/reducers/project/selectors';

export function useCanEdit(): boolean {
  const isAdminRole = useIsAdminRole();
  const isEditorRole = useIsEditorRole();

  const isNew = useAppSelector(isProjectStatusNew);
  const isEditorPending = useAppSelector(isProjectStatusEditorPending);
  const isEditingInProgress = useAppSelector(isProjectStatusEditingInProgress);
  const isAssigned = useAppSelector(isProjectStatusAssigned);
  const isProoferPending = useAppSelector(isProjectStatusProoferPending);
  const isInRetake = useAppSelector(isProjectStatusInReTake);
  const isDecline = useAppSelector(isProjectStatusDecline);
  const isDone = useAppSelector(isProjectStatusDone);
  const isWebSiteUptoDate = useAppSelector(isWebSiteUpToDateSelector);

  if (isAdminRole) return false;

  // return (
  //   isEditorRole &&
  //   !isNew &&
  //   !isEditorPending &&
  //   !isProoferPending &&
  //   !isDone &&
  //   !isDecline &&
  //   isWebSiteUptoDate
  // );
  return isWebSiteUptoDate &&
        (isEditorRole && (isAssigned || isEditingInProgress || isInRetake))
}
